import { render } from "./ThresholdDetails.vue?vue&type=template&id=36327a54&ts=true"
import script from "./ThresholdDetails.vue?vue&type=script&lang=ts"
export * from "./ThresholdDetails.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__